import type { ComponentPropsWithoutRef, ReactNode } from "react";
import classNames from "classnames";

export interface ActionButtonsProps extends ComponentPropsWithoutRef<"div"> {
  children: ReactNode;
  className?: string;
}

export const CanvasControls = ({
  children,
  className,
  ...rest
}: ActionButtonsProps) => (
  <div
    className={classNames("flex items-center justify-center gap-2", className)}
    data-testid="builder-ui-canvas-controls"
    {...rest}
  >
    {children}
  </div>
);
